import styled from 'styled-components';

export default styled.div`
  .submitButton {
    margin-top: 3rem;

    text-align: center;
  }
`;
